<template>
    <div class="register absolute">

        <div class="whiteBg">
            <div class="title">Register Account</div>
            <div class="list">
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-phone_"></use>
                        </svg>
                        <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{area}}</slot>
              <span><svg t="1566640213388" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2787" width="18" height="18"><path
                      d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                      p-id="2788"></path></svg></span>
           </span>
                        <input type="text" v-model="account" placeholder="9*********"/>
                    </div>
                </div>
                <div class="item">
                    <div class="align-left">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_1"></use>
                        </svg>
                        <input style="width: 2rem" type="text" v-model="v_code" placeholder="verification code"
                               class="codeIput"/>
                        <img style="width: 3.2rem;height: .8rem" :src="yz_img" @click="getVcode" class="code"/>
                    </div>
                </div>
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input :type="showPassword1 ? 'text' : 'password'" v-model="password" placeholder="Password"/>
                        <i class="r-eye-icon" @click="togglePasswordVisibility(1)"><img :src="showPassword1?eye_src2:eye_src1"></i>
                    </div>
                </div>
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input :type="showPassword2 ? 'text' : 'password'" v-model="password2" placeholder="Confirm password"/>
                        <i class="r-eye-icon" @click="togglePasswordVisibility(2)"><img :src="showPassword2?eye_src2:eye_src1"></i>
                    </div>
                </div>
            </div>
            <div class="logon" @click="toregister">register</div>
            <div class="tip">
                Have an existing account?
                <span @click="$router.push({ name: 'Login' })" class="font-color-blue"
                >Login</span>
            </div>
            <div class="tips">
                By clicking "register" I agree to Interesting mall
                <span @click="$router.push({ path: '/RegisterService' ,query:{id:10}})" class="font-color-blue">Privacy Policy</span>

                <!--<span @click="$router.push({ name: 'RegisterService' ,query:{id:9}})" class="font-color-blue">Privacy Policy</span>-->

            </div>
            <div class="club-tip">
                <b style="font-weight: bold;text-align: center;color: red"><p>IM Group's 9th anniversary!</p></b>
                <p>Registration bonus: <b>₱30-₱50</b></p>
                <p>First top up bonus: <b>₱30</b></p>
                <p>Club daily bonus: <b>₱2000</b></p>
                <p>Lucky bonus 3 times a week: <b>₱10000</b></p>
            </div>
        </div>
        <!-- <div class="bottom"></div> -->
    </div>
</template>

<script>
    import {register_new1, tp_captcha} from "@api/user";
    import {validatorDefaultCatch} from "@utils/dialog";
    import attrs, {required, alpha_num} from "@utils/validate";
    import cookie from "@utils/store/cookie";
    import dayjs from "dayjs";

    export default {
        name: "Register",
        data() {
            return {
                showPassword1:false,
                showPassword2:false,
                eye_src1:require('../../assets/images/eye1.png'),
                eye_src2:require('../../assets/images/eye2.png'),
                type: 'register',
                account: '',
                captcha: '123456',
                password: '',
                password2: '',
                area: '',
                yz_img: '',
                v_code: '',
                yz_key: '',
                bomb_btn: false,
            }
        },
        mounted: function () {
            this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
            this.getVcode();
        },
        watch: {
            $route() {
                // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
                this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
            },
        },
        methods: {
            togglePasswordVisibility(type) {
                if(type===1){
                    this.showPassword1 = !this.showPassword1
                }
                if(type===2){
                    this.showPassword2 = !this.showPassword2
                }
            },
            chooseArea: function () {
                this.$router.push({path: '/selectCode'})
            },
            //注册
            async toregister() {
                var that = this;
                const {account, captcha, password} = that;
                try {
                    await that
                        .$validator({
                            captcha: [
                                required(required.message("verification code")),
                                alpha_num(alpha_num.message("verification code"))
                            ],
                            password: [
                                required(required.message("password")),
                                attrs.range([6, 16], attrs.range.message("password")),
                                alpha_num(alpha_num.message("password"))
                            ]
                        })
                        .validate({account, captcha, password});
                } catch (e) {
                    return validatorDefaultCatch(e);
                }

                if (that.v_code === '') {
                    return this.$dialog.toast({mes: "Please fill in the verification code"});
                }

                if (that.password !== that.password2) {
                    return this.$dialog.toast({mes: "Two password input is not the same"});
                }
                register_new1({
                    account: String(that.area) + String(that.account),
                    captcha: that.captcha,
                    yz_key: that.yz_key,
                    v_code: that.v_code,
                    password: that.password,
                    password2: that.password2,
                    spread: cookie.get("spread")
                }).then(res => {
                    that.$dialog.success(res.msg);
                    that.formItem = 1;
                    that.$store.commit("LOGIN", res.data.token, dayjs(res.data.expires_time));
                    that.$router.replace({path: "/user/myPay",query:{r:1}});
                }).catch(res => {
                    that.$dialog.error(res.msg);
                    if(res.msg==='User already exists'){
                        that.$router.replace({path: "/login"});
                    }
                });
            },
            getVcode: function () {
                let that = this
                tp_captcha().then(res => {
                    that.yz_key = res.data.key
                    that.yz_img = res.data.img
                    // console.log(res)
                }).catch(res => {
                    console.log(res)
                });
            },
        },

    };
</script>

<style scoped>
    .tips {
        height: 1.1rem;
        text-align: center;
        /* line-height: 1.05rem; */
        font-size: 0.3rem;
        color: #cccccc;
    }
    .r-eye-icon{
        float: right;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .club-tip{
        color: #cccccc;
    }
    .club-tip p{
        padding: 5px 1px;
        /*margin-top: 10px;*/
    }
</style>
